module.exports = __webpack_public_path__ + "img/heroes_aboutus.570a0a38.png";